import React from 'react';

interface Props { bgImage?: string; }

export const Slide2Trade: React.FC<Props> = ({ bgImage }) => (
  <div className="bs-slide-inner">
    <div className="bs-slide-bg" aria-hidden="true">
      {bgImage ? (
        <div
          className="bs-slide-bg-img"
          style={{ backgroundImage: `url(${bgImage})` }}
        />
      ) : (
        <div className="bs-slide-bg--trade-fallback" />
      )}
      <div className="bs-overlay bs-overlay--heavy" />
    </div>

    <div className="bs-content">
      <span className="bs-label">TRADE &amp; INVEST</span>
      <h1 className="bs-headline">Real goods crossing real oceans.</h1>
      <p className="bs-subline">
        Invest in cargo. Track it live on the globe.<br />
        Watch your return come in.
      </p>
    </div>
  </div>
);
